import { render, staticRenderFns } from "./product-compact-card.vue?vue&type=template&id=4eff48ae&"
import script from "./product-compact-card.vue?vue&type=script&lang=js&"
export * from "./product-compact-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eff48ae')) {
      api.createRecord('4eff48ae', component.options)
    } else {
      api.reload('4eff48ae', component.options)
    }
    module.hot.accept("./product-compact-card.vue?vue&type=template&id=4eff48ae&", function () {
      api.rerender('4eff48ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/product-compact-card/product-compact-card.vue"
export default component.exports